import { DATE_FORMAT } from '@constants';
import DeleteIcon from '@mui/icons-material/Delete';
import { Chip, IconButton, Link, Tooltip, Typography } from '@mui/material';
import { Box } from '@mui/system';
import { GridColDef } from '@mui/x-data-grid';
import dayjs from 'dayjs';
import _ from 'lodash';

import {
  getFeedbackCategoryLabel,
  getSentimentLabel,
  mapESentimentAnalysisSubcategoryToValue,
} from 'src/features/Enterprise/SentimentAnalysis/utils';
import { FeedbackItem } from 'src/features/Enterprise/SentimentAnalysis/types';

interface Props {
  onClickEdit: (row: FeedbackItem) => void;
  onClickDelete: (row: FeedbackItem) => void;
}
export function getSentimentAnalysisColumns({ onClickDelete }: Props): GridColDef<FeedbackItem>[] {
  return [
    {
      field: 'title',
      headerName: 'Analysis Title',
      flex: 2,
      minWidth: 350,
      renderCell: ({ value }) => (
        <Tooltip title={value}>
          <Typography className="ellipsis" color="#3369E8">
            {value}
          </Typography>
        </Tooltip>
      ),
      resizable: true,
    },
    {
      field: 'url',
      headerName: 'Url',
      flex: 1.2,
      minWidth: 250,
      renderCell: ({ value }) => (
        <Tooltip title={value}>
          <Link className="ellipsis" href={value} target="_blank">
            {value}
          </Link>
        </Tooltip>
      ),
      resizable: true,
    },
    {
      field: 'category',
      headerName: 'Category',
      sortable: false,
      flex: 1,
      minWidth: 180,
      renderCell: ({ value, row }) =>
        !_.isNull(value) && !_.isUndefined(value) ? (
          <Tooltip title={row.categoryDescription}>
            <Chip color="default" label={getFeedbackCategoryLabel(value)} />
          </Tooltip>
        ) : (
          'N/A'
        ),
      resizable: true,
    },
    {
      field: 'subCategory',
      headerName: 'SubCategory',
      sortable: false,
      flex: 1,
      minWidth: 180,
      renderCell: ({ value, row }) =>
        !_.isNull(value) && !_.isUndefined(value) ? (
          <Tooltip title={row.subCategoryDescription}>
            <Chip color="default" label={mapESentimentAnalysisSubcategoryToValue(value)} />
          </Tooltip>
        ) : (
          'N/A'
        ),
      resizable: true,
    },
    {
      field: 'sentiment',
      headerName: 'Sentiment',
      sortable: false,
      flex: 0.5,
      minWidth: 120,
      renderCell: ({ value }) =>
        !_.isNull(value) && !_.isUndefined(value) ? (
          <Chip color="default" label={getSentimentLabel(value)} />
        ) : (
          'N/A'
        ),
      resizable: false,
    },
    {
      field: 'label',
      headerName: 'Label',
      sortable: false,
      flex: 0.5,
      minWidth: 100,
      renderCell: ({ value }) => (
        <Tooltip title={value}>
          <Typography className="ellipsis" color="#3369E8">
            {value}
          </Typography>
        </Tooltip>
      ),
      resizable: true,
    },
    {
      field: 'createdAt',
      headerName: 'Date of addition',
      flex: 1,
      minWidth: 180,
      renderCell: ({ value }) => dayjs(value).format(DATE_FORMAT),
      resizable: false,
    },
    {
      field: 'action',
      headerName: 'Action',
      width: 100,
      renderCell: ({ row }) => (
        <Box>
          {/* TODO: BE implement Edit feature */}
          {/* <IconButton onClick={() => onClickEdit(row)}>
            <EditIcon />
          </IconButton> */}
          <IconButton onClick={() => onClickDelete(row)}>
            <DeleteIcon />
          </IconButton>
        </Box>
      ),
      sortable: false,
      resizable: false,
    },
  ];
}
